import ReactECharts from "echarts-for-react";
import "./follower-pie.scss";
import { FollowerType } from "types";

function FollowerPie({ data, streamIds }: { data: FollowerType[]; streamIds: number[] }) {
    const outerLegend = getStreams();
    const innerLegend = ["All"];

    const getStreamId = (stream: string) => {
        return (
            {
                Twitter: 7,
                Facebook: 8,
                Instagram: 9,
                Youtube: 10,
                Linkedin: 11,
            }[stream] || ""
        );
    };

    function getStreams() {
        var streams = [];

        for (var stream of streamIds) {
            switch (stream) {
                case 7:
                    streams.push("Twitter");
                    break;
                case 8:
                    streams.push("Facebook");
                    break;
                case 9:
                    streams.push("Instagram");
                    break;
                case 10:
                    streams.push("Youtube");
                    break;
                case 11:
                    streams.push("Linkedin");
                    break;
            }
        }

        return streams;
    }

    const getColor = (stream: string) => {
        return (
            {
                Twitter: "#000",
                Facebook: "#3b5998",
                Instagram: "#e1306c",
                Youtube: "#f61c0d",
                Linkedin: "#2977c9",
                All: "#5cb85c",
            }[stream] || ""
        );
    };

    function getFollowerData(stream: string[]) {
        var followers = [{}];

        stream.map((x: string, i: number) => {
            var filtered;
            var latest;
            var followerCount = 0;

            if (data.length > 0) {
                if (x === "All") {
                    for (var stream of streamIds) {
                        filtered = data.filter((y) => y.StreamId === stream);
                        latest = filtered[filtered.length - 1];

                        if (latest) {
                            followerCount += latest.FollowerCount;
                        }
                    }
                } else {
                    filtered = data.filter((y) => y.StreamId === getStreamId(x));
                    latest = filtered[filtered.length - 1];

                    if (latest) {
                        followerCount = latest.FollowerCount;
                    }
                }
            }

            followers.push({
                name: x,
                value: followerCount,
                itemStyle: { color: getColor(x) },
            });
        });

        return followers;
    }

    return (
        <div className="follower-pie component">
            <div className="top">
                <p>Follower Comparison</p>
            </div>
            <div className="body">
                <ReactECharts
                    option={{
                        tooltip: {
                            formatter: "{a} <br/>{b}: {c} ({d}%)",
                        },
                        legend: [
                            {
                                data: innerLegend,
                                margin: 15,
                                x: "right",
                                top: "25%",
                                orient: "vertical",
                            },
                            {
                                data: outerLegend,
                                margin: 15,
                                top: 8,
                                x: "center",
                            },
                        ],
                        grid: {
                            left: 30,
                            right: 10,
                            top: 45,
                            bottom: 20,
                        },
                        series: [
                            {
                                name: "Total Followers",
                                type: "pie",
                                radius: ["0", "30%"],
                                center: ["50%", "60%"],
                                avoidLabelOverlap: true,
                                label: {
                                    show: false,
                                    position: "inner",
                                },
                                emphasis: {
                                    label: {
                                        show: false,
                                    },
                                },
                                labelLine: {
                                    show: false,
                                },
                                data: getFollowerData(innerLegend),
                            },
                            {
                                name: "Follower Comparison",
                                type: "pie",
                                radius: ["55%", "75%"],
                                center: ["50%", "60%"],
                                avoidLabelOverlap: true,
                                label: {
                                    show: false,
                                    position: "inner",
                                },
                                emphasis: {
                                    label: {
                                        show: false,
                                    },
                                },
                                labelLine: {
                                    show: false,
                                },
                                data: getFollowerData(outerLegend),
                            },
                        ],
                    }}
                />
            </div>
        </div>
    );
}

export default FollowerPie;
